export default __webpack_public_path__ + "static/media/logoVeloe.9271de59.png";